import { z, ZodSchema, SafeParseReturnType } from "zod";

// Input fields validation
export const requiredString = (message: string) => {
  return z.string({ required_error: message });
};
export const requiredNumber = (required: string, invalid: string) => {
  return z.number({
    required_error: required,
    invalid_type_error: invalid,
    message: invalid,
  });
};
export const optionalNumber = (invalid: string) => {
  return z.string().regex(numberRegExp, invalid).optional();
};
export const requiredDate = (message: string) => {
  return z.date({ required_error: message });
};

const numberRegExp = /^[0-9]+$/;

export const privacy = (message: string) => {
  return z
    .boolean({ required_error: message })
    .refine((value) => value === true, {
      message: message,
    });
};

export const e_mail = (required: string, invalid: string) => {
  return z.string({ required_error: required }).email({ message: invalid });
};
export const phoneRegExp = /^(\+|00)[1-9]\d{1,14}$/;

// export const phoneNumber = (message: string, requiredMessage?: string) => {
//   let schema = z.string().regex(phoneRegExp, message);
//   if (requiredMessage) {
//     schema = schema.min(1, requiredMessage);
//   }

//   return z.preprocess(
//     (val) => (typeof val === "string" ? val.replace(/\s+/g, "") : val),
//     requiredMessage ? schema : schema.optional().or(z.literal("")),
//   );
// };
export const phoneNumber = (message: string, requiredMessage?: string) => {
  // Create the base string schema with your custom required message
  const baseString = z.string({
    required_error: requiredMessage,
    invalid_type_error: requiredMessage,
  });

  const schema = baseString
    .trim()
    .transform((val) => val.replace(/\s+/g, "")) // transform is cleaner than preprocess here
    .pipe(
      // If there's a requiredMessage, enforce min(1).
      // Otherwise, allow empty string via a regex or optionality.
      requiredMessage
        ? z.string().min(1, requiredMessage).regex(phoneRegExp, message)
        : z.string().regex(phoneRegExp, message).optional().or(z.literal("")),
    );

  return schema;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const safeParseSchema = <T>(schema: ZodSchema, data: any) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const result: SafeParseReturnType<any, T> = schema.safeParse(data);

  if (!result.success) {
    return {
      flattenedErrors: result.error.flatten().fieldErrors,
    };
  } else {
    return { data: result.data, flattenedErrors: {} };
  }
};
